import {Component, OnInit} from '@angular/core';
import {KeycloakLoginOptions, KeycloakProfile} from "keycloak-js";
import {KeycloakService} from "keycloak-angular";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";

@Component({
	selector: 'app-nav',
	standalone: true,
	imports: [
		RouterLink,
		NgIf
	],
	templateUrl: './nav.component.html',
	styleUrl: './nav.component.css'
})
export class NavComponent implements OnInit {
	
	public isLoggedIn = false;
	public userProfile: KeycloakProfile | null = null;
	
	
	constructor(private readonly keycloak: KeycloakService) {
	
	}
	
	public async ngOnInit() {
		this.isLoggedIn = await this.keycloak.isLoggedIn();
		
		if (this.isLoggedIn) {
			this.userProfile = await this.keycloak.loadUserProfile();
		}
	}
	
	
	public login() {
		this.keycloak.login().then(r => console.log("ok"));
	}
	
	public logout() {
		this.keycloak.logout().then(() => {
			window.location.reload();
		});
	}
	
	
	public reset() {
		this.keycloak.login(<KeycloakLoginOptions>{action: "UPDATE_PASSWORD"}).then(() => {
			console.log("pw reset");
		});
	}
	
}
